(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomServiceTypeAttribute', CustomServiceTypeAttribute);

    CustomServiceTypeAttribute.$inject = ['$resource'];

    function CustomServiceTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-service-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
